import AppService from "./js/services/appService";
import CookieService from "./js/services/cookieService";

const classNames = {
    loading: '.js-loading',
    loadingActive: 'loading--active',
    page: '.js-page',
    pageActive: 'page--active',
    panel: '.js-panel',
    panelActive: 'panel--active',
    btnHome: '.js-home',
    slide: '.js-slide',
    slideActive: 'slide--active',
    btnShowLogin: '.js-btn-show-login',
    pageLogin: '.js-page-login',
    pagePasswordResetRequest: '.js-page-reset-request',
    pagePasswordResetRequestSent: '.js-page-reset-request-sent',
    pageRegister: '.js-page-register',
    pageRegistered: '.js-page-registered',
    pageCompleteRegistration: '.js-page-complete-reg',
    pageRegistrationComplete: '.js-page-registration-complete',
    pageRegistrationCompleteNotApproved: '.js-page-registration-complete-not-approved',
    pagePasswordReset: '.js-page-reset',
    pagePasswordResetComplete: '.js-page-reset-complete',
    pageEula: '.js-page-eula',
    btnNextPage: '.js-btn-next-page',
    btnRegister: '.js-btn-register',
    btnContinue: '.js-btn-continue',
    btnNextSlide: '.js-btn-next',
    btnSubmitAccount: '.js-btn-submit-account',
    btnCompleteRegistration: '.js-btn-complete-reg',
    btnLogin: '.js-btn-login',
    btnNotifications: '.js-btn-ntf',
    btnReloadLogin: '.js-btn-reload-login',
    btnResetRequest: '.js-btn-reset-request',
    btnForgottenPwd: '.js-btn-forgotten',
    btnReset: '.js-btn-reset',
    btnShowEula: '.js-btn-show-eula',
    btnCloseEula: '.js-btn-close-eula',
    progressBar: '.js-prog',
    progressBarP: '.js-prog-p',
    createAccount: '.js-create-account',
    formSubmitAccount: '.js-form-submit-account',
    formSubmitAccountError: '.js-form-submit-account-error',
    formCompleteRegistration: '.js-form-complete-reg',
    formCompleteRegistrationError: '.js-form-complete-reg-error',
    formLogin: '.js-form-login',
    formLoginError: '.js-form-login-error',
    formResetRequest: '.js-form-reset-request',
    formResetRequestError: '.js-form-reset-request-error',
    formReset: '.js-form-reset',
    formResetError: '.js-form-reset-error',
    createAccountActive: 'create-account--active',
    sliderControls: '.js-slider-controls',
    sliderControlsActive: 'slider__controls--active',
    pwReveals: '.js-pw-reveal',
    validateActive: 'validate--active',
    cbxEula: '.js-eula',
};

const pageTypes = {
    current: 'current',
    login: 'login',
    register: 'register',
    registered: 'registered',
    completeRegistration: 'completeRegistration',
    registrationComplete: 'registrationComplete',
    passwordResetRequest: 'passwordResetRequest',
    passwordResetRequestSent: 'passwordResetRequestSent',
    passwordReset: 'passwordReset',
    passwordResetComplete: 'passwordResetComplete',
    eula: 'eula'
}

//const regexPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#!@%$*])[A-Za-z\d#!@%$*]{8,}$/;
const regexPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?([^\w\s]|[_])).{8,}$/;
const eulaAccepted = CookieService.get("AROIaiTermsOfUseV1") != null ? true : false;
const rvt = document.querySelector('input[name="__RequestVerificationToken"]').value;
const t = document.getElementById("t").value;
const r = document.querySelector(".r").value;
const loading = document.querySelector(classNames.loading);
const pages = document.querySelectorAll(classNames.page);
const panels = document.querySelectorAll(classNames.panel);
const slides = document.querySelectorAll(classNames.slide);
const pageLogin = document.querySelector(classNames.pageLogin);
const pageRegister = document.querySelector(classNames.pageRegister);
const pageRegistered = document.querySelector(classNames.pageRegistered);
const pageCompleteRegistration = document.querySelector(classNames.pageCompleteRegistration);
const pageRegistrationComplete = document.querySelector(classNames.pageRegistrationComplete);
const pageRegistrationCompleteNotApproved = document.querySelector(classNames.pageRegistrationCompleteNotApproved);
const pagePasswordResetRequest = document.querySelector(classNames.pagePasswordResetRequest);
const pagePasswordResetRequestSent = document.querySelector(classNames.pagePasswordResetRequestSent);
const pagePasswordReset = document.querySelector(classNames.pagePasswordReset);
const pagePasswordResetComplete = document.querySelector(classNames.pagePasswordResetComplete);
const pageEula = document.querySelector(classNames.pageEula);
const homeBtns = document.querySelectorAll(classNames.btnHome);
const btnLogin = document.querySelector(classNames.btnLogin);
const btnNotifications = document.querySelector(classNames.btnNotifications);
const btnsReloadLogin = document.querySelectorAll(classNames.btnReloadLogin);
const btnShowLogins = document.querySelectorAll(classNames.btnShowLogin);
const btnNextSlide = document.querySelector(classNames.btnNextSlide);
const btnsContinue = document.querySelectorAll(classNames.btnContinue);
const btnsRegister = document.querySelectorAll(classNames.btnRegister);
const btnsNextPage = document.querySelectorAll(classNames.btnNextPage);
const btnSubmitAccount = document.querySelector(classNames.btnSubmitAccount);
const btnCompleteRegistration = document.querySelector(classNames.btnCompleteRegistration);
const btnPwReveals = document.querySelectorAll(classNames.pwReveals);
const btnForgottenPwd = document.querySelector(classNames.btnForgottenPwd);
const btnResetRequest = document.querySelector(classNames.btnResetRequest);
const btnReset = document.querySelector(classNames.btnReset);
const btnShowEula = document.querySelector(classNames.btnShowEula);
const btnCloseEula = document.querySelector(classNames.btnCloseEula);
const formLogin = document.querySelector(classNames.formLogin);
const formLoginError = document.querySelector(classNames.formLoginError);
const formSubmitAccount = document.querySelector(classNames.formSubmitAccount);
const formSubmitAccountError = document.querySelector(classNames.formSubmitAccountError);
const formCompleteRegistration = document.querySelector(classNames.formCompleteRegistration);
const formCompleteRegistrationError = document.querySelector(classNames.formCompleteRegistrationError);
const formResetRequest = document.querySelector(classNames.formResetRequest);
const formResetRequestError = document.querySelector(classNames.formResetRequestError);
const formReset = document.querySelector(classNames.formReset);
const formResetError = document.querySelector(classNames.formResetError);
const createAccount = document.querySelector(classNames.createAccount);
const sliderControls = document.querySelector(classNames.sliderControls);
const progressBar = document.querySelector(classNames.progressBar);
const progressBarPs = document.querySelectorAll(classNames.progressBarP);

let currentPage = 0;
let currentPanel = 0;
let currentSlide = 0;

if (eulaAccepted) {
    document.querySelector(classNames.cbxEula).checked = true;
}

const ShowPage = (pageType) => {
    pages.forEach(x => {
        x.classList.remove(classNames.pageActive)
    });

    switch (pageType) {
        case pageTypes.login:
            pageLogin.classList.add(classNames.pageActive);
            pageLogin.querySelector('.js-focus').focus();
            break;
        case pageTypes.registered:
            pageRegistered.classList.add(classNames.pageActive);
            break;
        case pageTypes.registrationComplete:
            pageRegistrationComplete.classList.add(classNames.pageActive);
            break;
        case pageTypes.pageRegistrationCompleteNotApproved:
            pageRegistrationCompleteNotApproved.classList.add(classNames.pageActive);
            break;
        case pageTypes.passwordResetRequest:
            pagePasswordResetRequest.classList.add(classNames.pageActive);
            break;
        case pageTypes.passwordResetRequestSent:
            pagePasswordResetRequestSent.classList.add(classNames.pageActive);
            break;
        case pageTypes.register:
            pageRegister.classList.add(classNames.pageActive);
            break;
        case pageTypes.passwordReset:
            pagePasswordReset.classList.add(classNames.pageActive);
            break;
        case pageTypes.passwordResetComplete:
            pagePasswordResetComplete.classList.add(classNames.pageActive);
            break;
        case pageTypes.completeRegistration:
            pageCompleteRegistration.classList.add(classNames.pageActive);
            pageCompleteRegistration.querySelector('.js-focus').focus();
            break;
        case pageTypes.eula:
            pageEula.classList.add(classNames.pageActive);
            break;
        case pageTypes.current:
            const pg = pages[currentPage];
            pg.classList.add(classNames.pageActive);

            const focusField = pg.querySelector('.js-focus');
            if (focusField) {
                focusField.focus();
            }
            break;
    }
}

const ShowLoading = () => {
    loading.classList.add(classNames.loadingActive);
}

const HideLoading = () => {
    loading.classList.remove(classNames.loadingActive);
}

const ShowPanel = () => {
    panels.forEach(x => {
        x.classList.remove(classNames.panelActive)
    });

    panels[currentPanel].classList.add(classNames.panelActive);
}

// Show specific Slide
const ShowSlide = () => {
    for (let i = 0; i < slides.length; i++) {
        slides[i].classList.remove(classNames.slideActive);
        progressBar.classList.remove("p" + (i + 1));
    }

    slides[currentSlide].classList.add(classNames.slideActive);
    progressBar.classList.add(`p${currentSlide + 1}`);

    if (currentSlide == slides.length - 1) {
        sliderControls.classList.remove(classNames.sliderControlsActive);
        createAccount.classList.add(classNames.createAccountActive);
    }
    else {
        sliderControls.classList.add(classNames.sliderControlsActive);
        createAccount.classList.remove(classNames.createAccountActive);
    }
}

const SubmitLoginForm = () => {
    if (formLogin) {
        if (formLogin.checkValidity()) {
            formLogin.classList.remove(classNames.validateActive);

            let formData = new FormData(formLogin);

            for (const input of formData.entries()) {
                const [key, value] = input;
                const element = formLogin.elements[key];

                if (element.type === 'checkbox') {
                    // Convert checkbox value to true/false
                    formData.set(key, element.checked);
                }
            }

            var request = {
                url: "/",
                formData: formData,
                successFn: () => {
                    CookieService.set(AppService.cookieConsts.userHasRegistered, 9999);
                    HardReloadApp();
                },
                errorFn: (data) => {
                    if (data && data.message) {
                        formLoginError.innerHTML = data.message
                    }
                    else {
                        formLoginError.innerHTML = "*An issue occurred, please retry."
                    }
                }
            };

            Post(request);
        }
        else {
            formLoginError.classList.add(classNames.validateActive);
            formLoginError.innerHTML = "*Email address and password required."
        }
    }

    return false;
}

const SubmitResetRequestForm = () => {
    if (formResetRequest) {
        if (formResetRequest.checkValidity()) {
            formResetRequest.classList.remove(classNames.validateActive);

            var request = {
                url: "/forgotten-password",
                formData: new FormData(formResetRequest),
                successFn: (data) => {
                    ShowPage(pageTypes.passwordResetRequestSent);
                },
                errorFn: (data) => {
                    if (data && data.message) {
                        formResetRequestError.innerHTML = data.message
                    }
                    else {
                        formResetRequestError.innerHTML = "*An issue occurred, please retry."
                    }
                }
            };

            Post(request);
        }
        else {
            formResetRequest.classList.add(classNames.validateActive);
            formResetRequestError.innerHTML = "Email Reqd."
        }
    }

    return false;
}

const SubmitResetForm = () => {
    if (formReset) {
        if (formReset.checkValidity()) {
            formReset.classList.remove(classNames.validateActive);
            const pw = document.getElementById("NewPassword1").value;

            if (!regexPattern.test(pw)) {
                formCompleteRegistrationError.innerHTML = "*Password should be 8 to 15 chars long, contain at least: one upper/lower case letter, one number and one of these chars #!@%$*"
                return false;
            }

            var request = {
                url: "/reset-password",
                formData: new FormData(formReset),
                successFn: (data) => {
                    ShowPage(pageTypes.passwordResetComplete);
                },
                errorFn: (data) => {
                    if (data && data.message) {
                        formResetError.innerHTML = data.message
                    }
                    else {
                        formResetError.innerHTML = "*An issue occurred, please retry."
                    }
                }
            };

            Post(request);
        }
        else {
            formReset.classList.add(classNames.validateActive);
            formResetError.innerHTML = "Password Reqd."
        }
    }

    return false;
}

const SubmitCreateAccountForm = () => {
    if (formSubmitAccount) {
        if (formSubmitAccount.checkValidity()) {
            formSubmitAccount.classList.remove(classNames.validateActive);

            var request = {
                url: "/sign-up",
                formData: new FormData(formSubmitAccount),
                successFn: (data) => {
                    ShowPage(pageTypes.registered);
                },
                errorFn: (data) => {
                    if (data && data.message) {
                        formSubmitAccountError.innerHTML = data.message
                    }
                    else {
                        formSubmitAccountError.innerHTML = "*An issue occurred, please retry."
                    }
                }
            };

            Post(request);
        }
        else {
            formSubmitAccount.classList.add(classNames.validateActive);
            formSubmitAccountError.innerHTML = "Email Reqd. Full Name Reqd (2 to 100 chars max)."
        }
    }

    return false;
}

const SubmitCompleteRegistrationForm = () => {
    if (formCompleteRegistration) {
        if (formCompleteRegistration.checkValidity()) {
            formCompleteRegistration.classList.remove(classNames.validateActive);
            const pw = document.getElementById("Password1").value;

            if (!regexPattern.test(pw)) {
                formCompleteRegistrationError.innerHTML = "*Password should be 8 to 15 chars long, contain at least: one upper/lower case letter, one number and one of these chars #!@%$*"
                return false;
            }

            var request = {
                url: "/sign-up/complete",
                formData: new FormData(formCompleteRegistration),
                successFn: (data) => {
                    if (data && data.message && data.message === "LogIn") {
                        ShowPage(pageTypes.registrationComplete);
                    }
                    else {
                        ShowPage(pageTypes.pageRegistrationCompleteNotApproved);
                    }

                    // Show Install Prompts
                    CookieService.set(AppService.cookieConsts.userHasRegistered, 9999);
                    document.querySelector('.js-app-scope').classList.add('install-prompts');
                },
                errorFn: (data) => {
                    if (data && data.message) {
                        formCompleteRegistrationError.innerHTML = data.message
                    }
                    else {
                        formCompleteRegistrationError.innerHTML = "*An unspecified issue occurred, please retry."
                    }
                }
            };

            Post(request);
        }
        else {
            formCompleteRegistration.classList.add(classNames.validateActive);
            formCompleteRegistrationError.innerHTML = "*Please complete all required fields."
        }
    }

    return false;
}

// POST a form 
const Post = (request) => {
    ShowLoading();

    fetch(request.url, {
        method: "post",
        body: request.formData,
        headers: {
            'Accept': 'application/json',
            'RequestVerificationToken': rvt
        }
    }).then(response => {
        if (response.ok) {
            response.json().then(data => {
                request.successFn(data);
            })
        } else {
            response.json().then(data => {
                request.errorFn(data);
            })
        }

        HideLoading();
    }).catch(error => {
        request.errorFn()
        HideLoading();
    });
}

const HardReloadApp = (hash) => {
    let loc = '/';

    if (hash) {
        loc = `${loc}#${hash}`;
    }

    window.location = loc;
}

const Init = () => {
    // Set first Panel to active
    if (panels) {
        const fullURL = window.location.href;

        // Extract the hash value from the URL
        const hashIndex = fullURL.indexOf("#");
        const hashValue = hashIndex !== -1 ? fullURL.slice(hashIndex) : "";

        if (hashValue === "") {
            panels[0].classList.add(classNames.panelActive);
        }
        else {
            switch (hashValue.toLowerCase()) {
                case "#login":
                    ShowPage(pageTypes.login);;
                    break;
                case "#registered":
                    ShowPage(pageTypes.registered);
                    break;
                default:
                    panels[0].classList.add(classNames.panelActive);
                    break;
            }
        }
    }

    // Event handler for Home btns
    if (homeBtns) {
        homeBtns.forEach(btn => {
            btn.addEventListener("click", () => {
                //currentPage = 0;
                //currentPanel = 0;
                //currentSlide = 0;

                //ShowSlide();
                //ShowPanel();
                //ShowPage(pageTypes.current);
                HardReloadApp();
            });
        });
    }

    // Event handler for Next Panel button
    if (btnsContinue) {
        btnsContinue.forEach(btn => {
            btn.addEventListener("click", () => {
                if (currentPanel < panels.length - 1) {
                    currentPanel++;
                    ShowPanel();
                }
            });
        });
    }

    // Event handler for Next Page button
    if (btnsNextPage) {
        btnsNextPage.forEach(btn => {
            btn.addEventListener("click", () => {
                if (currentPage < pages.length - 1) {
                    currentPage++;
                    ShowPage(pageTypes.current);
                }
            });
        });
    }

    // Event handler for Next Slide button
    if (btnNextSlide) {
        btnNextSlide.addEventListener("click", () => {
            if (currentSlide < slides.length - 1) {
                currentSlide++;
                ShowSlide();
            }
        });
    }

    // Event handler for Show Eula Page
    if (btnShowEula) {
        btnShowEula.addEventListener("click", () => {
            ShowPage(pageTypes.eula);
        });
    }

    // Event handler for Close Eula Page
    if (btnCloseEula) {
        btnCloseEula.addEventListener("click", () => {
            ShowPage(pageTypes.login);
        });
    }

    // Event handler for Show Login form button
    if (btnShowLogins) {
        btnShowLogins.forEach(btn => {
            btn.addEventListener("click", () => {
                ShowPage(pageTypes.login);
            });
        });
    }

    // Event handler for Show Register form button
    if (btnsRegister) {
        btnsRegister.forEach(btn => {
            btn.addEventListener("click", () => {
                ShowPage(pageTypes.register);
            });
        });
    }

    // Event handler for progress bar element clicks
    if (progressBarPs) {
        progressBarPs.forEach(p => {
            p.addEventListener("click", (e) => {
                if (currentSlide > -1 && currentSlide < slides.length) {
                    currentSlide = parseInt(e.target.dataset.id);
                    ShowSlide();
                }
            });
        });
    }

    // Event handler for reveal password button clicks
    if (btnPwReveals) {
        btnPwReveals.forEach(btn => {
            btn.addEventListener('click', e => {
                if (e) {
                    var target = document.getElementById(e.currentTarget.dataset.target);

                    if (target.type === "password") {
                        e.currentTarget.classList.add('icon--visibility--white');
                        e.currentTarget.classList.remove('icon--visibility-off--white');
                    } else {
                        e.currentTarget.classList.add('icon--visibility-off--white');
                        e.currentTarget.classList.remove('icon--visibility--white');
                    }

                    target.type === "password" ? target.type = "text" : target.type = "password";
                }
            });
        });
    }

    // Event handler for Login button
    if (btnLogin) {
        btnLogin.addEventListener("click", () => {
            SubmitLoginForm();
        });
    }

    if (btnNotifications) {
        btnNotifications.addEventListener("click", async () => {
            if (typeof window.OfferNotifications === 'function') {
                window.OfferNotifications().then((msg) => {
                    formLoginError.innerHTML = msg;
                });            
            }            
        });
    }

    if (btnsReloadLogin) {
        btnsReloadLogin.forEach(btn => {
            btn.addEventListener("click", () => {
                HardReloadApp('login');
            });
        });
    }

    // Event handler for Submit Account Create button click
    if (btnSubmitAccount) {
        btnSubmitAccount.addEventListener("click", () => {
            SubmitCreateAccountForm();
        });
    }

    // Event handler for Submit Account Create button click
    if (btnCompleteRegistration) {
        btnCompleteRegistration.addEventListener("click", () => {
            SubmitCompleteRegistrationForm();
        });
    }

    // Event handler for Submit Password Reset Request button click
    if (btnResetRequest) {
        btnResetRequest.addEventListener("click", () => {
            SubmitResetRequestForm();
        });
    }

    // Event handler for Submit Password Reset button click
    if (btnReset) {
        btnReset.addEventListener("click", () => {
            SubmitResetForm();
        });
    }

    // Event handler for Forgotten Password button click
    if (btnForgottenPwd) {
        btnForgottenPwd.addEventListener("click", () => {
            ShowPage(pageTypes.passwordResetRequest);
        });
    }

    if (t && t !== '' && r && r !== '') {
        ShowPage(pageTypes.completeRegistration);
    }
    else if (n && n !== '' && r !== '') {
        ShowPage(pageTypes.passwordReset);
    }
}

Init();